import type {DataTestProps} from '@benchling/js-test-utils';
import {Center, Loader, createStyles} from '@mantine/core';
import React from 'react';

interface ModelHubLoadingStateProps {
  /** Section loaders sit inside a page that already has a header; 'sm' keeps them proportionate. */
  size?: 'sm' | 'md';
  /** Forwarded so page-level tests can target a specific loader. */
  testProps?: DataTestProps;
}

export default function ModelHubLoadingState({
  size = 'md',
  testProps,
}: ModelHubLoadingStateProps): JSX.Element {
  const {classes} = useStyles();

  return (
    <Center className={classes.root} mih={240} {...testProps}>
      <Loader size={size} />
    </Center>
  );
}

const useStyles = createStyles({
  root: {
    flex: 1,
  },
});
